export default function checkIntersection($el, callback) {
  const $scrollListener = document.querySelector('.scroll-listener');
  let observerActive = false;

  function onScrollUpdate() {
    if (observerActive === false) {
      observerActive = true;

      setTimeout(() => {
        if (
          $el.getBoundingClientRect().top < window.innerHeight &&
          $el.getBoundingClientRect().bottom >= 0 &&
          $el.clientWidth > 0 &&
          $el.clientHeight > 0
        ) {
          callback();
          $scrollListener.Component['scroll-listener'].removeObserver(onScrollUpdate)
        }
    
        observerActive = false;
      }, 200);
    }
  }

  onScrollUpdate();

  $scrollListener.Component['scroll-listener'].addObserver(onScrollUpdate)

}



// WEBPACK FOOTER //
// ./src/scripts/utils/check-intersection.js